var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{staticClass:"FileList",attrs:{"fields":_vm.fields,"items":_vm.content,"hover":""},on:{"row-clicked":_vm.onRowClick},scopedSlots:_vm._u([{key:"cell(thumbnail)",fn:function(ref){
var item = ref.item;
return [_c('Thumbnail',{attrs:{"src":item.thumbnailUrlData.url,"size":"50"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }